import { render } from "./request-partner.vue?vue&type=template&id=47727662&ts=true"
import script from "./request-partner.vue?vue&type=script&lang=ts"
export * from "./request-partner.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__